module.exports = __webpack_public_path__ + "img/bomber_factory_small.a9d415a9.png";